module.exports = __webpack_public_path__ + "img/template_1.b8e41d6e.jpg";